import React from 'react'
import Header from './header'
import IEventedComponent, { messageTypes } from './IEventedComponent'

import '../css/bootstrap.css'
import '../css/site.css'
import { ResizedEvent } from '../lib/messages'

interface IProps {}

interface IState {}

const Layout = class extends IEventedComponent<IProps, IState> {
  componentDidMount() {
    if (window) {
      window.addEventListener('resize', this.handleResize)
    }
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.handleResize)
    }
    super.componentWillUnmount()
  }

  handleResize = () => {
    this.publish<ResizedEvent>(messageTypes.onResized, {})
  }

  render() {
    return (
      <>
        <Header />
        {this.props.children}
      </>
    )
  }
}

export default Layout
